import MobileNav from './components/MobileNav';
import SocialSharePopup from './components/SocialSharePopup';
import NavDropdownPosition from './components/NavDropdownPosition';
import SinglePostsSlider from './components/SinglePostsSlider';
import SetMenuType from './components/SetMenuType';
import FixedHeader from './components/FixedHeader';

import sal from 'sal.js';

/**
 * Controller class.
 *
 * Standardizes how we hook into event listeners and create components.
 */
class Controller {
	constructor() {
		this.init();

		window.addEventListener('resize', this.resized);
		window.addEventListener('load', this.loaded);
	}

	init() {
		MobileNav.init();
		SocialSharePopup.init();
		NavDropdownPosition.init();
		SinglePostsSlider.init();
		SetMenuType.init();
		FixedHeader.init();
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
	resized() {
		MobileNav.vhMobileHeight();
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
	loaded() { }
}

// Run controller.
new Controller();

sal({
	selector: '.page-content > section .cms',
	root: null,
	animateClassName: 'loaded',
	threshold: 0.01,
});
